import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ButtonTable from '../common/table/buttonTable';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import readXlsxFile from 'read-excel-file/web-worker'

import { setModoTela, initForm } from './analiticaImportacaoMesActions';

class AnaliticaImportacaoMesForm extends Component {

	componentDidMount() {

		let initSeletorArquivo = () => {
			const fileSelector = document.createElement('input');
			fileSelector.setAttribute('type', 'file');
			fileSelector.addEventListener("change", async (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
						|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
						setError('Selecione apenas (.XLSX)');
						return;
					}

					let tabela = [];
					await readXlsxFile(file, { sheet: 1 }).then((rows) => {
						tabela = rows;
					});

					this.props.initForm({
						...this.props.formularioValues,
						tabela: tabela
					});

					reader.readAsDataURL(file);

					initSeletorArquivo();

				}
			});

			this.fileSelector = fileSelector;

		}

		initSeletorArquivo();

	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row alignCenter>
							<Field
								name='id_unidade'
								component={Select}
								options={this.props.listaUnidade}
								label='Unidade'
								cols='12 12 4 3'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>
						<Row alignCenter>								
							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo'
								cols='12 12 4 3'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>
						<Row alignCenter>
							<Field
								name='competencia_inicial'
								component={LabelAndInputMask}
								label='Competência Inicial' placeholder='Informe a data'
								cols='12 6 2 2'
								maxWidth={160}
								mask='99/9999' />

							<Field
								name='competencia_final'
								component={LabelAndInputMask}
								label='Competência Final' placeholder='Informe a data'
								cols='12 6 2 2'
								maxWidth={160}
								mask='99/9999' />
						</Row>

						<br /><br />

						<Row alignCenter>
							{!this.props.formularioValues.tabela &&
							<Grid cols='6 6 3 2'>
								<Button
									text='Selecionar Arquivo'
									type={'primary'}
									icon={'fa fa-chevron-left'}
									event={() => {
										this.fileSelector.click();
									}} />
							</Grid>}

							{this.props.formularioValues.tabela &&
							<Grid cols='6 6 3 2'>
								<div 
									style={{
										fontSize: 16,
										fontWeight: 'bold',
										backgroundColor: '#035e00',
										color: '#ffffff',
										paddingTop: 8,
										paddingLeft: 12,
										paddingRight: 12,
										paddingBottom: 8,
										borderRadius: 8,
										textAlign: 'center'
									}}>
									<i class='fas fa-file-excel'style={{ marginRight: 4 }}></i>
									Arquivo Carregado
								</div>
							</Grid>}
						</Row>

						<br /><br />
	
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>								
								<Button
									text='Importar'
									submit
									type={'success'}
									icon={'fa fa-check'}
									disabled={
										!this.props.formularioValues.id_unidade
										|| !this.props.formularioValues.id_tipo
										|| !this.props.formularioValues.competencia_inicial
										|| !this.props.formularioValues.competencia_final
										|| !this.props.formularioValues.tabela
									} />
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

AnaliticaImportacaoMesForm = reduxForm({form: 'analiticaImportacaoMesForm', destroyOnUnmount: false})(AnaliticaImportacaoMesForm);
const mapStateToProps = state => ({
	sessao: state.auth.analiticaImportacaoMes,
	formularioValues: getFormValues('analiticaImportacaoMesForm')(state),
	registro: state.analiticaImportacaoMes.registro,
	listaUnidade: state.analiticaImportacaoMes.listaUnidade,
	listaTipo: state.analiticaImportacaoMes.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AnaliticaImportacaoMesForm);
